import { render, staticRenderFns } from "./MensajeriaCheckout.vue?vue&type=template&id=1f14cb18&scoped=true&"
import script from "./MensajeriaCheckout.vue?vue&type=script&lang=js&"
export * from "./MensajeriaCheckout.vue?vue&type=script&lang=js&"
import style0 from "./MensajeriaCheckout.vue?vue&type=style&index=0&id=1f14cb18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f14cb18",
  null
  
)

export default component.exports